import React, {useEffect, useState} from "react";
import "./style.scss";

import Tabination from "../../../reusableComponents/Tabination";

import PlansLayout from "../../../layouts/Plans/index";
import {useDispatch, useSelector} from "react-redux";
import {getPlans} from "../../../store/reducers/accountSlice";
import MainHeader from "../../../layouts/pageLayout/MainHeader";
import {useLocation, useParams} from "react-router-dom";

function Plans() {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const {idToken} = useSelector((state) => state.auth);
  const {plans} = useSelector((state) => state.account);
  const activeTabParams = useParams();
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);

  useEffect(() => {
    dispatch(getPlans({selectedBrand}));
  }, [idToken,selectedBrand]);
  // useEffect(() => {
  //   setPlans(plansValue);
  // }, [plansValue]);
  useEffect(() => {
    setActiveTab(Number(activeTabParams?.id));
  }, [activeTabParams?.id]);

  const tabItems = [];
  const tabHeaders = [];

  plans?.data?.forEach((item) => tabHeaders?.push(item?.name));
  // const data = plans?.data?.filter((plan) => plan.name === tabHeaders[1]);

  // plans?.data?.map((item, index) =>

  //   tabItems.push({
  //     name: item.name,
  //     content: <div key={index}>{/* <PlansLayout plans={plans?.data?.filter((plan) => plan.name === tabItems[index])} /> */}</div>,
  //   }),
  // );

  plans?.data?.map((item, index) =>
    tabItems.push({
      name: item.name.replace(/account/i, "").trim(),
      content: <div key={index}>{/* <PlansLayout plans={plans?.data?.filter((plan) => plan.name === item.name)} /> */}</div>,
    }),
  );

  const location = useLocation();
  const path = location.pathname.split("/")[2];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="funding_eval_container">
      <PlansLayout
        tabItems={tabItems}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        plans={plans?.data?.filter((item, index) => item?.name === tabHeaders[activeTab])}
      />
    </div>
  );
}

export default Plans;

/* <div className="mainPageHolder">
  <div className="mainPageHolder-T-C">
    <div className="mainPageHolder-T">
      <MainHeader headerName="Dashboard" />
    </div>
  </div>
  <div className="mainPageHolder-B">
  
  //THE COMPONENT CODE SHOULD BE HERE (OLD CODE OF THE PAGE)
  
  </div>
</div> */
